import { Address, OperationArea } from "@/interfaces/domain/Address";
import { api } from "@/services/api";

import { Location } from "../location";

export type CreateAddressParams = {
  cep: string;
  street: string;
  neighborhood: string;
  number: string;
  completion: string;
  reference: string;
  city: string;
  state: string;
  location?: Location;
};

export async function getOperatiosAreasRequest() {
  const { data } = await api.get<OperationArea[]>("/enderecos/locais-atuacao");
  return data;
}

export async function createAddressRequest(params: CreateAddressParams): Promise<Address> {
  const { data } = await api.post<Address>("/enderecos", {
    rua: params.street,
    numero: params.number,
    bairro: params.neighborhood,
    cidade: params.city,
    estado: params.state,
    pais: "Brasil",
    latitude: params.location?.latitude || 0,
    longitude: params.location?.longitude || 0,
    cep: params.cep,
    complemento: params.completion,
    referencia: params.reference,
  });
  return data;
}

export async function deleteAddressRequest(id: string): Promise<void> {
  await api.delete(`/enderecos/${id}`);
}
